import React, { useRef, useEffect } from 'react';
import { Input, Typography } from '@material-tailwind/react';
import MsgInputError from './MsgInputError';

const ButtonDinamic = ({
  cssDiv,
  type,
  label,
  placeholder,
  errors,
  register,
  validations,
  formCamp,
  required,
  disabled = false,
  valor,
  onChange,
  onBlur,
  onKeyDown,
}) => {
  const errorTexts = {
    required: 'Este campo é obrigatório',
  };
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('blur', onBlur);
    }

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('blur', onBlur);
      }
    };
  }, []);

  return (
    <div className={`w-[100%] flex-1 ${cssDiv}`}>
      <Typography
        variant="h6"
        className="mb-1 text-left font-medium  capitalize text-black dark:!text-darkText"
      >
        {label} {required && '*'}
      </Typography>
      <Input
        inputRef={inputRef}
        onChange={onChange}
        onKeyDown={onKeyDown}
        type={type}
        color="blue"
        size="lg"
        variant="outlined"
        placeholder={placeholder}
        className={`${
          !!errors
            ? `focus:!border-t-red-500  !border-red-500 text-white !font-bold !bg-red-400`
            : ' placeholder:text-gray-500  text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 bg-white '
        } placeholder:opacity-100   bg-white dark:bg-darkBgInput uppercase ${
          disabled && 'disabled:bg-gray-600 '
        }`}
        labelProps={{
          className: 'hidden ',
        }}
        value={valor || ''}
        containerProps={{
          className: 'min-w-full',
        }}
        error={!!errors}
        {...register(formCamp, validations)}
        autoComplete="off"
        disabled={disabled}
      />
      {errors && <MsgInputError text={errors[formCamp]?.message || errorTexts.required} />}
    </div>
  );
};

export default ButtonDinamic;
